import { Image } from "antd";
import type { CSSProperties, FC } from "react";

import arrows from "../assets/arrows.png";
import arrowsUp from "../assets/arrowup.png";
import card from "../assets/card.png";
import collapse from "../assets/collapse.png";
import dashboard from "../assets/dashboard.png";
import device from "../assets/device.png";
import document from "../assets/document.png";
import dots from "../assets/dots.png";
import endpoint from "../assets/endpoint.png";
import flag from "../assets/flag.png";
import home from "../assets/home.png";
import iconBook from "../assets/Icon_book_whitepaper.png";
import iconCentralHub from "../assets/Icon_central_hub.png";
import iconIntegration from "../assets/icon_integration.png";
import iconProgressData from "../assets/Icon_progress_data.png";
import mpos from "../assets/mPOS.png";
import ok from "../assets/ok.png";
import site from "../assets/site.png";
import flagFrance from "./flags/flag-france.svg";
import flagGermany from "./flags/flag-germany.svg";
import flagUSA from "./flags/flag-usa.svg";

const ICON_SIZE = 17 as const;

export enum CustomIconCodes {
    FlagFrance = "FlagFrance",
    FlagUSA = "FlagUSA",
    FlagGermany = "FlagGermany",
    Arrows = "Arrows",
    ArrowsUp = "ArrowsUp",
    Card = "Card",
    Device = "Device",
    Document = "Document",
    Dots = "Dots",
    Site = "Site",
    Home = "Home",
    Ok = "Ok",
    Flag = "Flag",
    Endpoint = "Endpoint",
    Collapse = "Collapse",
    Dashboard = "Dashboard",
    CardData = "CardData",
    CentralHub = "CentralHub",
    Server = "Server",
    Terminal = "Terminal",
    ProgressData = "ProgressData",
    Book = "Book",
    Integration = "Integration",
}

const allCustomIconsMap = new Map<string, string | unknown>([
    [CustomIconCodes.FlagUSA, flagUSA],
    [CustomIconCodes.FlagGermany, flagGermany],
    [CustomIconCodes.FlagFrance, flagFrance],
    [CustomIconCodes.Dots, dots],
    [CustomIconCodes.Arrows, arrows],
    [CustomIconCodes.ArrowsUp, arrowsUp],
    [CustomIconCodes.Home, home],
    [CustomIconCodes.Site, site],
    [CustomIconCodes.Endpoint, endpoint],
    [CustomIconCodes.Ok, ok],
    [CustomIconCodes.Device, device],
    [CustomIconCodes.Flag, flag],
    [CustomIconCodes.Card, card],
    [CustomIconCodes.Document, document],
    [CustomIconCodes.Collapse, collapse],
    [CustomIconCodes.Dashboard, dashboard],
    [CustomIconCodes.CentralHub, iconCentralHub],
    [CustomIconCodes.Terminal, mpos],
    [CustomIconCodes.ProgressData, iconProgressData],
    [CustomIconCodes.Book, iconBook],
    [CustomIconCodes.Integration, iconIntegration],
]);

export type CustomIconProps = Readonly<{
    iconSource: CustomIconCodes;
    iconSize?: number;
    style?: CSSProperties;
}>;

export const CustomIcon: FC<CustomIconProps> = ({ iconSource, iconSize = ICON_SIZE, style }) => {
    const customIcon = allCustomIconsMap.get(iconSource);
    if (typeof customIcon === "string") {
        return <Image src={customIcon} style={style || { borderRadius: "4px" }} width={iconSize} preview={false} />;
    }
    throw new Error("Could not set up custom svg icon.");
};
